"use client"
import {
  x_up_default
} from "./chunk-XHO4ETXO.js";

// src/modules/x-up/x-up.tsx
import { jsx } from "react/jsx-runtime";
var mXUp = ({
  _id,
  className = "",
  content,
  labels,
  sequence
}) => {
  if (!content?.cards) return null;
  return /* @__PURE__ */ jsx(
    "section",
    {
      className: `${className}${sequence === 1 ? " pt-[10rem]" : ""}`,
      "data-module-sequence": sequence,
      "data-module-type": "mXUp",
      id: _id,
      children: /* @__PURE__ */ jsx(x_up_default, { id: `${_id}_xup`, ...content })
    }
  );
};
var x_up_default2 = mXUp;

export {
  x_up_default2 as x_up_default
};
